module.exports = __webpack_public_path__ + "img/riversoft_logo.b285d28d.png";